import { EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { HttpClient, HttpHandler, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { apiBaseUrlInterceptor } from './api-base-url.interceptor';

export const apiClientFactory = (baseUrl: string, interceptors: HttpInterceptorFn[] = []) => (): HttpClient => {
  const httpHandler = inject(HttpHandler);
  const injector = inject(EnvironmentInjector);

  const chain = [apiBaseUrlInterceptor(baseUrl), ...interceptors].reduceRight(
    interceptorsChainReducerFactory(injector),
    (request, handler) => handler(request),
  );

  return new HttpClient({ handle: (req: HttpRequest<unknown>) => chain(req, (req) => httpHandler.handle(req)) });
};

const interceptorsChainReducerFactory =
  (injector: EnvironmentInjector) =>
  (next: HttpInterceptorFn, interceptor: HttpInterceptorFn): HttpInterceptorFn =>
  (request, handler) =>
    runInInjectionContext(injector, () => interceptor(request, (downstreamRequest) => next(downstreamRequest, handler)));
